import React from "react";
import { useNavigate } from "react-router-dom";
import companyLogo from "./assets/epic-logo.svg";
import agentAvatar from "./assets/engie.png";
import epicWave from "./assets/epic-wave.svg";
import "./App.css";

const EPIC_BLACK = "#1A1A1A";
const EPIC_WHITE = "#FFFFFF";
const EPIC_ACCENT = "#0078F2";

function IconStopwatch() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="13" r="8" stroke={EPIC_WHITE} strokeWidth="2" />
      <path d="M12 9v5l3 2" stroke={EPIC_WHITE} strokeWidth="2" strokeLinecap="round" />
      <path d="M9 3h6" stroke={EPIC_WHITE} strokeWidth="2" strokeLinecap="round" />
      <path d="M12 3v2" stroke={EPIC_WHITE} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconVideo() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="6" width="13" height="12" rx="2" stroke={EPIC_WHITE} strokeWidth="2" />
      <path d="M16 10l5-3v10l-5-3v-4z" stroke={EPIC_WHITE} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

function IconBrand() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <text
        x="12"
        y="18"
        textAnchor="middle"
        fontFamily="'Inter', 'Helvetica Neue', Arial, sans-serif"
        fontSize="16"
        fontWeight="700"
        fill={EPIC_ACCENT}
      >
        E
      </text>
    </svg>
  );
}

function IconCalendarHero() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2" stroke={EPIC_WHITE} strokeWidth="1.8" />
      <path d="M4 9h16" stroke={EPIC_WHITE} strokeWidth="1.8" />
      <path d="M8 3v4M16 3v4" stroke={EPIC_WHITE} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function IconShieldHero() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3l7 3v6c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6l7-3z"
        stroke={EPIC_WHITE}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M9 12l2 2 4-4" stroke={EPIC_WHITE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.951H.957C.348 6.174 0 7.55 0 9s.348 2.826.957 4.049l3.007-2.342z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.582C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.951L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z"
      />
    </svg>
  );
}

export default function CalendlySchedule() {
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      let sessionId = localStorage.getItem("session_id");

      if (!sessionId) {
        const response = await fetch(`${API_URL}/api/new-user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) throw new Error("Failed to create session");

        const data = await response.json();
        sessionId = data.session_id;
        localStorage.setItem("session_id", sessionId);
      }

      localStorage.removeItem(`confirmation_done_${sessionId}`);
      localStorage.removeItem(`booking_summary_${sessionId}`);

      navigate("/login");
    } catch (error) {
      console.error("Login error:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="calendy-div cc-schedule-page epic-schedule-page">
      <div className="calendy-grid cc-schedule-card">
        <div className="cc-schedule-left">
          <div className="cc-schedule-left-bg" aria-hidden="true">
            <div className="cc-epic-geo cc-epic-geo-1" />
            <div className="cc-epic-geo cc-epic-geo-2" />
            <div className="cc-epic-geo cc-epic-geo-3" />
            <div className="cc-epic-geo cc-epic-geo-4" />
          </div>
          <div className="cc-schedule-profile">
            <div className="cc-schedule-logo-bar">
              <img src={companyLogo} alt="Epic Games" className="cc-schedule-logo" />
            </div>

            <div className="cc-schedule-avatar-wrap">
              <img src={agentAvatar} alt="Engie DeVora" className="cc-schedule-avatar" />
              <span className="cc-schedule-status" aria-hidden="true" />
            </div>

            <h3 className="cc-schedule-name">Engie DeVora</h3>
            <p className="cc-schedule-title">Talent Acquisition Manager</p>
            <p className="cc-schedule-company">
              <IconBrand />
              <span>Epic Games</span>
            </p>
            <p className="cc-schedule-tagline">Create the Future of Interactive Entertainment</p>
          </div>

          <div className="cc-schedule-divider" />

          <div className="cc-schedule-details">
            <div className="cc-schedule-detail-row">
              <div className="cc-schedule-icon-circle">
                <IconStopwatch />
              </div>
              <div className="cc-schedule-detail-text">
                <strong>30 Minute Meeting</strong>
                <span>30 min</span>
              </div>
            </div>
            <div className="cc-schedule-detail-row">
              <div className="cc-schedule-icon-circle">
                <IconVideo />
              </div>
              <div className="cc-schedule-detail-text">
                <strong>Web Conferencing details</strong>
                <span>Provide upon confirmation</span>
              </div>
            </div>
          </div>

          <div className="cc-schedule-wave-footer">
            <img src={epicWave} alt="" className="cc-schedule-wave" aria-hidden="true" />
            <div className="cc-schedule-footer-links">
              <a href="#cookie-settings">Cookie settings</a>
              <span className="cc-schedule-footer-sep">|</span>
              <a href="#privacy">Privacy Policy</a>
            </div>
          </div>
        </div>

        <div className="cc-schedule-right cc-schedule-right-hero">
          <div className="cc-schedule-right-bg" aria-hidden="true" />
          <div className="cc-schedule-right-overlay" aria-hidden="true" />

          <div className="cc-schedule-hero">
            <div className="cc-schedule-hero-icons-row">
              <div className="cc-schedule-hero-icon-badge">
                <IconCalendarHero />
              </div>
              <div className="cc-schedule-hero-icon-badge">
                <IconShieldHero />
              </div>
            </div>

            <h2 className="cc-schedule-heading">Let&apos;s get you set for success</h2>
            <p className="cc-schedule-intro">
              To help us keep things secure and relevant, please sign in with Google. We&apos;ll verify your
              meeting based on public information to ensure a better experience.
            </p>

            <button
              type="button"
              className="cc-schedule-google-btn cc-schedule-google-btn-primary"
              onClick={handleGoogleLogin}
            >
              <span className="cc-schedule-google-icon-wrap">
                <GoogleIcon />
              </span>
              <span className="cc-schedule-google-label">Sign in with Google</span>
            </button>

            <p className="cc-schedule-privacy-note">
              We&apos;ll never post without your permission. Your information is safe with us.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
